import {useParams, useRouteMatch} from 'react-router-dom';
import {PlaylistForm} from '../../../../../../../components/playlist-form/playlist-form';
import {CaregiverMode} from '../../../../../../../enums';

export default function PlaylistDetailsSystemAdministratorOfficeScreen() {
  // Get params
  let {id}: {id?: string} = useParams();
  if (id?.toLowerCase() === 'create') {
    id = undefined;
  }

  // The `path` lets us build <Route> paths that are
  // relative to the parent route, while the `url` lets
  // us build relative links.
  let {url} = useRouteMatch();

  return (
    <PlaylistForm
      caregiverMode={CaregiverMode.SystemAdministrator}
      canWrite={true}
      redirectUrl={id ? `${url.replace(`/${id}`, '')}` : `${url.replace('/create', '')}`}
      showExitButton={id ? false : true}
      showPageTitle={id ? false : true}
    />
  );
}
